<div class="filter-container">
    <label class="filter-item-title" [for]="uniqueId">
        <svg class="filter-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 4a1 1 0 011-1h16a1 1 0 011 1v2.586a1 1 0 01-.293.707l-6.414 6.414a1 1 0 00-.293.707V17l-4 4v-6.586a1 1 0 00-.293-.707L3.293 7.293A1 1 0 013 6.586V4z"/>
        </svg>
        <span>{{filterConfig.label}}</span>
    </label>

    @if (filterConfig.options.length === 0) {
    <div class="filter-no-data">No data</div>
    }

    <div class="toggle-switch">
        <input type="checkbox" 
               [id]="uniqueId" 
               [checked]="filterConfig.selectedValue === '' ? false : true" 
               (change)="onChange($event)">
        <label class="toggle-slider" [for]="uniqueId"></label>
    </div>
</div>